import { Icon } from '@gx-design/icon';
import { useEffect, useRef } from 'react';

export const PreRedirectPageView: React.FC = () => {
    const progressRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        const redirectUrl = 'https://www.pisos.com/es/login/profesionales';

        const el = progressRef.current;

        const onAnimationEnd = () => {
            window.location.href = redirectUrl;
        };

        if (el) {
            el.addEventListener('animationend', onAnimationEnd);
        }

        // fallback in case animationend doesn't fire
        const timeout = window.setTimeout(() => {
            window.location.href = redirectUrl;
        }, 30000);

        return () => {
            if (el) {
                el.removeEventListener('animationend', onAnimationEnd);
            }
            clearTimeout(timeout);
        };
    }, []);

    return (
        <div className="redirect">
            <header className="redirect__header">
                <img
                    alt="Indomio"
                    src="/bundles/base/getrix/common/img/country/es/logo/logo.svg"
                />
            </header>

            <main className="redirect__card">
                <div className="redirect__status">
                    <span className="redirect__status-dot" />
                    Redirigiendo...
                </div>

                <h1 className="redirect__title">
                    Queremos simplificar tu gestión para que ahorres tiempo.
                </h1>

                <p className="redirect__description">
                    Ahora puedes gestionar tus anuncios de{' '}
                    <span>Indomio.es</span> directamente desde{' '}
                    <strong>Pisos.com</strong>, un único acceso que te permite
                    publicar simultáneamente en ambos portales.
                </p>

                <div className="redirect__info">
                    Te redirigiremos a Pisos.com
                    <span className="redirect__info-arrow">
                        <Icon name="arrow-long-right" />
                    </span>
                </div>

                <div className="redirect__progress">
                    <div ref={progressRef} className="redirect__progress-bar" />
                </div>

                <a
                    href="https://www.pisos.com/es/login/profesionales"
                    className="redirect__link"
                >
                    Ir directamente a Pisos.com
                    <span className="redirect__link-icon">
                        <Icon name="external-link" />
                    </span>
                </a>
            </main>
        </div>
    );
};
